module.exports = __webpack_public_path__ + "img/logo.011f99f1.png";